import { STATUS_CODES } from '../../../../config/status';

const mappedStatusCodes = Object.values(STATUS_CODES);

export const requestsReportInitialValues = {
  servicos: [],
  dtCadastro: { dtInicio: '', dtFim: '' },
  dtFinalizacao: { dtInicio: '', dtFim: '' },
  nmOperador: '',
  nuDocumentoOperador: '',
  setores: [],
  usuarios: [],
  nuSolicitacao: '',
  situacoesCadastro: [...mappedStatusCodes],
  agrupamento: null,
  boExibirResumo: true,
};
